module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_j_normal.8b21d22f.png";